import React, { Component } from "react";
import { Container, InputGroup, FormControl, Row, Col, Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpellCheck, faCameraRetro, faUpload, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import CreatableSelect from "react-select/creatable";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import 'react-html5-camera-photo/build/css/index.css';
import '../../../assets/css/modal-dialogs.css';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Resizer from "react-image-file-resizer";

import "../../../assets/css/modals.css";

import ConfigService from "../../../services/ConfigService.js";
import CoreService from "../../../services/CoreService.js";
import TextRecognitionService from "../../../services/TextRecognitionService";
import LocalImageDbService from "../../../services/LocalImageDbService";
import BlobStorageService from "../../../services/BlobStorageService";
import IdentityService from "../../../services/IdentityService";

import ErrorImg from "../../../assets/images/ImageNotFound.png";

const components = {
  DropdownIndicator: null
};

const createOption = (label) => ({
  label,
  value: label,
});

const MAX_USERIMAGE_WIDTH = 2048;
const MAX_USERIMAGE_HEIGHT = 2048;


//let url = 'https://cdn.shopify.com/s/files/1/0234/8017/2591/products/young-man-in-bright-fashion_925x_f7029e2b-80f0-4a40-a87b-834b9a283c39.jpg'
const toDataURL = url => fetch(url)
      .then(response => response.blob())
      .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
     }))


  //Here is code for converting "Base64" to javascript "File Object".***
  function dataURLtoFile(dataurl, filename) {
     var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
     bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
     while(n--){
     u8arr[n] = bstr.charCodeAt(n);
     }
   return new File([u8arr], filename, {type:mime});
  }


  /*
  toDataURL(url)
  .then(dataUrl => {
     console.log('Here is Base64 Url', dataUrl)
     var fileData = dataURLtoFile(dataUrl, "imageName.jpg");
     console.log("Here is JavaScript File Object",fileData)
     fileArr.push(fileData)
   })

  */


   const getUrlExtension = (url) => {
    return url
      .split(/[#?]/)[0]
      .split(".")
      .pop()
      .trim();
  }


// if we have a file, great. But we may have a blob. We may need to convert blob to file. 
const resizeFile = (file, maxWidth, maxHeight, compressFormat, quality, rotation, outputType) => //, minWidth, minHeight) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth?? MAX_USERIMAGE_WIDTH,
      maxHeight?? MAX_USERIMAGE_HEIGHT,
      compressFormat?? "PNG",
      quality?? 100,
      rotation?? 0,
      (uri) => {
        resolve(uri);
      },
      outputType?? "base64"
    );
  });

  const blobToFile = (blob, fileName) =>
  {
    const result = new File([blob], fileName, {type: blob.type});
    return result;
  }


export default class UserImageModal extends Component 
{
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      value: [],
      descript: "",
      dataUri: null,
      thumbUri: null,
      idealFacingMode: FACING_MODES.ENVIRONMENT,
      slides: [],
      slideAttribs: [],
      slideIdx: -1,
      defaultTag: "",
      mode: "camera"
    };

    this.imageGalleryRef = React.createRef();

    this.configService = new ConfigService();
    this.coreService = new CoreService();
    this.blobStorageService = new BlobStorageService();
    this.localImageDbService = new LocalImageDbService();

    this.handleDescriptChange = this.handleDescriptChange.bind(this);
    this.onTakePhoto = this.onTakePhoto.bind(this);
    this.onTakePhotoAnimationDone = this.onTakePhotoAnimationDone.bind(this);
    this.onCloseDialog = this.onCloseDialog.bind(this);

    this.showCamera = this.showCamera.bind(this);
    this.toggleIdealFacingMode = this.toggleIdealFacingMode.bind(this);

    this.onSlide = this.onSlide.bind(this);
    this.onFileUpload = this.onFileUpload.bind(this);
    this.onTextRecognitionRequest = this.onTextRecognitionRequest.bind(this);
    this.onDeleteGalleryImageRequest = this.onDeleteGalleryImageRequest.bind(this);
    this.onSaveUserImage = this.onSaveUserImage.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onClose = this.onClose.bind(this);

    this.onCameraStart = this.onCameraStart.bind(this);
    this.onCameraStop = this.onCameraStop.bind(this);
  }


  componentDidUpdate(prevProps) {

    if (prevProps.cardId !== this.props.cardId) {
      this.setState({
        defaultValue: [createOption(this.props.cardId)]
      })
    }

    
  }

  fileToUri = async (url) => {
    var b64 = await this.getBase64FromUrl(url);
    var result = this.b64toBlob(b64);
    return result;
  }

  getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }



onCameraStart(stream)
{
  console.log("onCameraStart:");
}

onCameraStop()
{
  console.log("onCameraStop:");
}

  showCamera() {
    this.setState({ mode: "camera" });
  }

  toggleIdealFacingMode(ev) {
    var newIdealFacingMode = (ev.target.id === "idealFacingModeUser") ? FACING_MODES.USER : FACING_MODES.ENVIRONMENT;
    this.setState({ idealFacingMode: newIdealFacingMode });
  }

  handleDescriptChange(ev) {
    if (this.state.slideIdx < 0) return;
    var newSlideAttribs = this.state.slideAttribs;
    newSlideAttribs[this.state.slideIdx].descript = ev.target.value;
    this.setState({
      descript: ev.target.value,
      slideAttribs: newSlideAttribs
    });
    //this.props.onValueChange(this.Id, ev.target.value);

  }

  handleChange = (value, actionMeta) => {
    if (this.state.slideIdx < 0) return;
    console.group("Value Changed");
    console.log(value);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    var newSlideAttribs = this.state.slideAttribs;
    newSlideAttribs[this.state.slideIdx].value = value;
    this.setState(
      {
        slideAttribs: newSlideAttribs,
        value: value
      }
    );
  };

  handleInputChange = (inputValue) => {
    if (this.state.slideIdx < 0) return;
    var newSlideAttribs = this.state.slideAttribs;
    newSlideAttribs[this.state.slideIdx].inputValue = inputValue;
    this.setState(
      {
        slideAttribs: newSlideAttribs,
        inputValue: inputValue
      });
  };

  handleKeyDown = (event) => {
    const { inputValue, value } = this.state;
    if (!inputValue) return;
    if ((event.key === "Enter") || (event.key === "Tab")) {
      console.group("Value Added");
      console.log(value);

      console.groupEnd();
      if (this.state.slideAttribs.length < 0) return;
      var newSlideAttribs = this.state.slideAttribs;
      newSlideAttribs[this.state.slideIdx].inputValue = "";
      newSlideAttribs[this.state.slideIdx].value = [...value, createOption(inputValue)];
      this.setState(
        {
          slideAttribs: newSlideAttribs,
          inputValue: "",
          value: [...value, createOption(inputValue)],
        }
      );
      event.preventDefault();
    }
  };

  onDeleteGalleryImageRequest() {
    if (this.state.slideIdx === -1) return;
    var newSlides = this.state.slides;
    var newSlideAttribs = this.state.slideAttribs;
    newSlides.splice(this.state.slideIdx, 1);
    newSlideAttribs.splice(this.state.slideIdx, 1);
    var newSlideIdx = (newSlides.length === 0) ? -1 :
      (this.state.slideIdx > newSlides.length - 1) ? newSlides.length - 1 : this.state.slideIdx;
    var newMode = (newSlides.length > 0) ? "gallery" : "camera";
    this.setState({
      slides: newSlides,
      slideAttribs: newSlideAttribs,
      slideIdx: newSlideIdx,
      mode: newMode
    });
    if (newSlideIdx > -1)
    {
      // this is how you move to the proper index.
      this.imageGalleryRef.current.slideToIndex(newSlideIdx);
    }
  }

  async onTakePhoto(dataUri) {

  }

  async onTakePhotoAnimationDone(dataUri) 
  {
    if (this.state.slides.length === 0) {
      this.setState({ slideIdx: 0 });
    }
    var newSlides = this.state.slides;

    var tempFileName = IdentityService.makeUuid();
    var dataUrl = await toDataURL(dataUri);
    var dataFile = dataURLtoFile(dataUrl, tempFileName + "." + getUrlExtension(dataUrl));
    var thumbUri = await resizeFile(dataFile, MAX_USERIMAGE_WIDTH, MAX_USERIMAGE_HEIGHT, 'PNG');
    newSlides.push({ "original": dataUri, "thumbnail": thumbUri });
    var newSlideIdx = newSlides.length-1;
    var newSlideAttribs = this.state.slideAttribs;
    newSlideAttribs.push({ "descript": "", "ext": "png", "inputValue": "", "value": this.state.defaultValue, "type": "dataUri" });

    this.setState({
      dataUri: dataUri,
      thumbUri: thumbUri,
      slides: newSlides,
      slideAttribs: newSlideAttribs,
      slideIdx: newSlideIdx,
      mode: "gallery"
    });
    if (this.imageGalleryRef?.current)
    {
      this.imageGalleryRef.current.slideToIndex(newSlideIdx);
    }
  }

  async onFileUpload(e) {
    e.stopPropagation()
    console.log(e.target.files);
    var newSlides = this.state.slides;
    var newSlideAttribs = this.state.slideAttribs;
    for (var i = 0; i < e.target.files.length; i++) {
      if ((e.target) && (e.target.files[i])) 
      {
        var imgUrl = URL.createObjectURL(e.target.files[i]);
        var ext = e.target.files[i].type.split("/")[1];
        const originalHeight = e.target.files[i].height;
        const originalWidth = e.target.files[i].width;
        var dataUri = await resizeFile(e.target.files[i], originalWidth, originalHeight, 'png');
        var thumbUri = await resizeFile(e.target.files[i], 200, 200, 'png');

        //var dataUri = await this.getBase64FromUrl(imgUrl);

        if (this.state.slides.length === 0) {
          this.setState({ slideIdx: 0 });
        };
        newSlides.push({ "original": dataUri, "thumbnail": thumbUri });
        newSlideAttribs.push({ "descript": "", "ext": 'png', "inputValue": "", "value": this.state.defaultValue, "type": "file" });

        //newSlides.push({ "original": imgUrl, "thumbnail": imgUrl });
        //newSlideAttribs.push({ "descript": "", "ext": ext, "inputValue": "", "value": this.state.defaultValue, "type": "file" });
      }
    }
    var newSlideIdx = newSlides.length-1;
    this.setState({
      dataUri: dataUri,
      thumbUri: thumbUri,
      slides: newSlides,
      slideIdx: newSlideIdx,
      slideAttribs: newSlideAttribs,
      mode: "gallery"
    });
    if (this.imageGalleryRef.current)
    {
      this.imageGalleryRef.current.slideToIndex(newSlideIdx);
    }

  }

  async onTextRecognitionRequest() {
    var sld = this.state.slides[this.state.slideIdx];
    var attrib = this.state.slideAttribs[this.state.slideIdx];
    var dataUri = (attrib.type === "file") ? await this.getBase64FromUrl(sld.original) : sld.original;
    var recognitionResult = await new TextRecognitionService().fetchTextRecognition(dataUri); //this.state.dataUri);
    if (recognitionResult.hasError) return;
    var annotations = recognitionResult.dataResult.responses[0].textAnnotations.map((ar) => {return ar.description});
    var newValue = this.state.value;
    for (var i = 1; i < annotations.length; i++) {
      // we start with one because the first is an aggregate. I'll need to rip through and try to identify values
      newValue.push(createOption(annotations[i]));
    }
    this.setState({ value: newValue })
    //console.log(result);
  }



  async onSave(ev)
   {
    for (var i = 0; i < this.state.slides.length; i++) {
      var sld = this.state.slides[i];
      var attrib = this.state.slideAttribs[i];
      var dataUri = (attrib.type === "file") ? await this.getBase64FromUrl(sld.original) : sld.original;
      var thumbUri = (attrib.type === "file") ? await this.getBase64FromUrl(sld.thumbnail) : sld.thumbnail;
      var fileNameId = IdentityService.makeUuid();
      var ky = fileNameId + '-img';
      var thumbKy = fileNameId + '-thumb';
      var val = { id: ky, ext: attrib.ext, descript: attrib.descript, tags: attrib.value, dataUri: dataUri, 
        thumbnailId: thumbKy, thumbnailExt: attrib.ext, thumbnailUri: thumbUri };
      var saveResult = await this.onSaveUserImage(val);
    }
    this.setState({
      mode: "camera"
    })
    this.onClose();
  }

  onClose()
  {
    this.setState({
      dataUri: null,
      thumbUri: null,
      descript: "",
      value: [],
      inputValue: "",
      slides: [],
      slideAttribs: [],
      slideIdx: -1,
      mode: "gallery"
    });
    this.props.onRequestCameraDialogClose(false);
  }


  async onSaveUserImage(imgObj) 
  {
    // does valuebag already have an images node?
    if (this.props.cardId === "completedloadphoto") 
    {
      this.props.onValueChange("completedloadphoto", true);
      //newValueBag["completedloadphoto"] = true;
    }
    let img = { "id": imgObj.id, "ext": imgObj.ext, "thumbnailId": imgObj.thumbnailId, "descript": imgObj.descript, "tags": imgObj.tags };
    var imgs = (!this.props.valueBag["userimages"]) ? []  : this.props.valueBag["userimages"];
    imgs.push(img);
    this.props.onValueChange("userimages", imgs);

    //this.auth.saveLocalSuspendedObservation(this.state.valueBag.gcid, this.state.schemaId, this.state.valueBag.inspector, newValueBag);
    
    // we're going to PUSH a new card into the images group
    // and hope it re-renders!
    this.props.onInsertSchemaCard("notes", "Images",
      {
        "id": imgObj.id, "disallowToggle": true,
        "title": ((imgObj.descript) && (imgObj.descript !== "")) ? imgObj.descript: "user image" , "fieldType": "userimage", "arrayValue": true,  "parentId": "userimages", "descript": imgObj.descript,
        "tags": imgObj.tags, "dataUri": imgObj.dataUri, 
        "thumbnailExt": imgObj.thumbnailExt, "thumbnailUri": imgObj.thumbnailUri, "colspan": 1
      });

    var result = await this.localImageDbService.addImage(this.props.gcid, imgObj.dataUri, imgObj.id);
    var thumbResult = await this.localImageDbService.addImage(this.props.gcid, imgObj.thumbnailUri, imgObj.thumbnailId);
    return result;   
  }



  onSlide(e) {
    console.log("onSlide: ");
    console.info(e);
    this.setState({ slideIdx: e });
    if (this.state.slideIdx < 0) {
      this.setState(
        { descript: "", value: [], inputValue: "" });
    }
    else {
      console.log("Slide Attribs: ");
      console.info(this.state.slideAttribs[e]);
      this.setState(
        {
          descript: this.state.slideAttribs[e].descript,
          value: this.state.slideAttribs[e].value,
          inputValue: this.state.slideAttribs[e].inputValue
        }
      );
    }


  }

  onCloseDialog() {
    this.setState({
      dataUri: null,
      descript: "",
      value: [],
      inputValue: "",
      slides: [],
      slideAttribs: [],
      slideIdx: -1,
      mode: "gallery"
    });
    this.props.onRequestCameraDialogClose();
  }

  render() {

    const { inputValue, value } = this.state;
    const isFullScreen = true;


    const textRecognition = ((this.state.dataUri) && (this.state.mode === "gallery")) ?
      <span>
        <Button id="textRecognitionRequest" onClick={this.onTextRecognitionRequest}>
          <FontAwesomeIcon id="textRecognitionRequest" icon={faSpellCheck} />
          ~Scan Text
        </Button>
      </span>
      : <span />;

    const removeSlide = (this.state.slideIdx !== -1) ?
      <span>
        <Button id="deleteImageRequest" onClick={this.onDeleteGalleryImageRequest}>
          <FontAwesomeIcon id="textRecognitionRequest" icon={faTrashAlt} />
          ~Remove Pic
        </Button>
      </span> : <span />


    const cameraWin = (this.state.mode === "camera") ?
      <Row>
        <Col>
          <Camera
            idealFacingMode={this.state.idealFacingMode}
            isImageMirror={false}
            isFullScreen={isFullScreen}
            onTakePhoto={(dataUri) => { this.onTakePhoto(dataUri); }}
            onTakePhotoAnimationDone={this.onTakePhotoAnimationDone}
            onCameraStart={(stream) => this.onCameraStart(stream)}
            onCameraStop={this.onCameraStop}
          />
        </Col>
      </Row> :
      <span />


    const galleryWin = (this.state.mode === "gallery") ?
      <Row>
        <ImageGallery
          ref={this.imageGalleryRef}
          lazyLoad={true}
          items={this.state.slides}
          showBullets={false}
          showIndex={false}
          showThumbnails={true}
          thumbnailPosition="left"
          showFullscreenButton={false}
          showPlayButton={false}
          
          onSlide={(e) => this.onSlide(e)}
          onErrorImageURL={ErrorImg}
        />
      </Row> :
      <span />;


    const galleryOptions = (this.state.mode === "gallery") ?
      <div>
        <Row style={{ marginTop: "5px" }}>
          <Col>
            <FormControl id="photoDescriptTextBox"
              autoFocus
              textAlign="left"
              placeholder="Comments..."
              aria-describedby="basic-addon2"
              name="imageDescription"
              value={this.state.descript}
              onChange={(e) => this.handleDescriptChange(e)}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "5px" }}>
          <Col>
            <CreatableSelect
              components={components}
              inputValue={inputValue}
              isClearable
              isMulti
              menuIsOpen={false}
              onChange={this.handleChange}
              onInputChange={this.handleInputChange}
              onKeyDown={this.handleKeyDown}
              placeholder="Optionally type a tag and press enter..."
              value={value}
            />
          </Col>

        </Row>
        <Row style={{ marginTop: "5px", justifyContent: "space-evenly" }}>
          {textRecognition}
          {removeSlide}
        </Row>
      </div> :
      <span />

    var showCamButton = "initial" ? this.state.mode === "camera" : "none"

    return (
      <Modal
        show={this.props.show}
        onHide={this.onCloseDialog}
      >
        <Modal.Header closeButton>
          <Modal.Title>Inspection Photo - {this.props.cardId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>

            {cameraWin}
            {galleryWin}
            {galleryOptions}

          </Container>
        </Modal.Body>
        <Modal.Footer id="cam-modal-footer">

          <span>
            <Button id="cam-camera-button" onClick={this.showCamera} disabled={this.state.mode === "camera"}><FontAwesomeIcon id="cameraMode" icon={faCameraRetro} /> ~Take Pic </Button>
            <Button id="cam-upload-button">
              <input type="file" id="files" style={{ display: "none" }} accept="image/*" multiple="true" onChange={(e) => this.onFileUpload(e)}></input>
              <label classname={"icon-circle"} for="files"><FontAwesomeIcon id="fileMode" icon={faUpload} />~Upload</label>
            </Button>
          </span>

          <span id="cam-save-buttongroup">
            <Button id="cam-save-button" variant="secondary" disabled={(this.state.slides.length < 1)} onClick={(ev) => this.onSave(ev)}>Save</Button>
            <Button id="cam-cancel-button" variant="secondary" onClick={this.onCloseDialog}>Cancel</Button>
          </span>

        </Modal.Footer>
      </Modal>
    );
  }
}
